import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const SiparisDetaylari = () => {
  document.title = "Sipariş Detayları | HarmanaGEL";

  const [detaylar, setDetaylar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetaylar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/SIPARIS_DETAY?$top=500&$orderby=ID desc&$expand=ILANLAR($select=AD)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setDetaylar(result.value);
    } catch (err) {
      setError("Sipariş detayları yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDetaylar();
  }, []);

  const toplamTutar = useMemo(() => detaylar.reduce((s, d) => s + parseFloat(d.SATIS_FIYATI || 0), 0), [detaylar]);
  const toplamKomisyon = useMemo(() => detaylar.reduce((s, d) => s + parseFloat(d.KOMISYON_TUTARI || 0), 0), [detaylar]);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Sipariş ID",
      accessorKey: "SIPARIS_ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-medium">#{cell.getValue()}</span>,
    },
    {
      header: "İlan",
      accessorKey: "ILANLAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const i = cell.getValue();
        return i ? <span className="fw-medium">{i.AD}</span> : <span className="text-muted">İlan #{cell.row.original.ILAN_ID}</span>;
      },
    },
    {
      header: "Adet",
      accessorKey: "ADET",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-medium">{cell.getValue()}</span>,
    },
    {
      header: "Satış Fiyatı",
      accessorKey: "SATIS_FIYATI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => (
        <span className="fw-bold text-success">
          {parseFloat(cell.getValue() || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺
        </span>
      ),
    },
    {
      header: "Komisyon Oranı",
      accessorKey: "KOMISYON_ORANI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span className="text-muted">%{parseFloat(v).toFixed(2)}</span> : "-";
      },
    },
    {
      header: "Komisyon Tutarı",
      accessorKey: "KOMISYON_TUTARI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span className="fw-medium">{parseFloat(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</span> : "-";
      },
    },
    {
      header: "Net Tutar",
      accessorKey: "NET_TUTAR",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span className="fw-bold">{parseFloat(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</span> : "-";
      },
    },
    {
      header: "Teslimat ID",
      accessorKey: "TESLIMAT_ID",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => <span>#{cell.getValue() || "-"}</span>,
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Sipariş Detayları" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row className="mb-3">
            <Col md={4}>
              <Card className="bg-primary text-white">
                <CardBody className="d-flex align-items-center gap-3">
                  <i className="bx bx-receipt fs-1" />
                  <div>
                    <h5 className="mb-0">{detaylar.length}</h5>
                    <small>Toplam Sipariş Detayı</small>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="bg-success text-white">
                <CardBody className="d-flex align-items-center gap-3">
                  <i className="bx bx-money fs-1" />
                  <div>
                    <h5 className="mb-0">{toplamTutar.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</h5>
                    <small>Toplam Satış Tutarı</small>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="bg-info text-white">
                <CardBody className="d-flex align-items-center gap-3">
                  <i className="bx bx-percent fs-1" />
                  <div>
                    <h5 className="mb-0">{toplamKomisyon.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</h5>
                    <small>Toplam Komisyon</small>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Sipariş Detayları</h4>
                    <Button color="primary" size="sm" onClick={fetchDetaylar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={detaylar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Sipariş detayı ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SiparisDetaylari;
